import { ErrorMessages, FortressErrorMessage, GeneralErrors, RiseUpErrors } from 'constants/errors'
import { useCallback, useState } from 'react'
import { consoleLog } from 'utils/simpleLogger'

const useErrorMessage = () => {
  const [errorMessage, setErrorMessage] = useState('')

  const getFriendlyErrorMessage = useCallback((error: string) => {
    const errorMap = new Map()

    errorMap.set(FortressErrorMessage.InvalidPhoneNumber, ErrorMessages.DuplicatePhoneNumber)
    errorMap.set(FortressErrorMessage.InvalidCardName, ErrorMessages.InvalidCardName)
    errorMap.set(FortressErrorMessage.IncompleteCardDetails, ErrorMessages.IncompleteCardDetails)
    errorMap.set(FortressErrorMessage.ExpiredCard, ErrorMessages.ExpiredCard)
    errorMap.set(FortressErrorMessage.DuplicateSSN, ErrorMessages.DuplicateSSN)
    errorMap.set(FortressErrorMessage.DuplicateCard, ErrorMessages.DuplicateCard)
    errorMap.set(FortressErrorMessage.DuplicateEmail, ErrorMessages.DuplicateEmail)
    errorMap.set(FortressErrorMessage.InvalidCreditCardNumber, ErrorMessages.InvalidCreditCardNumber)
    errorMap.set(FortressErrorMessage.DuplicatePhoneNumber, ErrorMessages.DuplicatePhoneNumber2)
    errorMap.set(FortressErrorMessage.InvalidEIN, ErrorMessages.InvalidEIN)
    errorMap.set(GeneralErrors.InvalidOnboardingGroupLink, ErrorMessages.InvalidOnboardingGroupLink)
    errorMap.set(RiseUpErrors.DuplicatePhoneNumber, ErrorMessages.DuplicatePhoneNumber)
    errorMap.set(RiseUpErrors.DuplicateSSN, ErrorMessages.DuplicateSSN)
    errorMap.set(RiseUpErrors.LimitCreateTrade, ErrorMessages.LimitCreateTrade)
    errorMap.set(RiseUpErrors.ExternalAccountIsLinked, ErrorMessages.ExternalAccountIsLinked)

    try {
      let errorMsg: string | undefined = undefined
      errorMap.forEach((value, key) => {
        if (error.includes(key)) {
          errorMsg = value
        } else if (key.split(' ')[3] === 'ssn' && error.includes(key.split(' ')[3])) {
          errorMsg = value
        }
      })

      if (errorMsg) {
        setErrorMessage(errorMsg)
      } else {
        setErrorMessage('Unexpected error occured.')
      }
    } catch (error) {
      consoleLog('useErrorMessage Error', error)
      setErrorMessage('Unexpected error occured.')
    }
  }, [])

  return { errorMessage, getFriendlyErrorMessage, setErrorMessage }
}

export default useErrorMessage
